import React from 'react';

import { ItemGroupProps } from 'types/ItemGroupProps';
import * as S from './styles';

interface FocusProps {
  data: ItemGroupProps;
  phoneWidth: number;
}

export default function Focus({ data, phoneWidth }: FocusProps) {
  return (
    <S.container>
      <p>{data.name || 'No name'} </p>
    </S.container>
  );
}
